import { throttle } from '~/rage/decorators';
import { IObservable, Subject } from '~/rage/utils';
import { GreenScreenParamConfig, GreenScreenParams, RgbColor } from '~/shared';
import {
	IGreenScreenService,
	IGreenScreenVehicleModel,
} from './greenScreenServiceTypes';

export class GreenScreenServiceStub implements IGreenScreenService {
	private vehicleModels = new Subject<IGreenScreenVehicleModel[]>([]);
	private cameraParams = new Subject<GreenScreenParamConfig[]>([]);

	constructor() {
		const vehicleModels = Array(30).fill({
			model: 'bmw_m3',
			name: 'BMW M3',
		});
		this.vehicleModels.next(vehicleModels);

		const cameraParams = [
			{
				name: 'Угол обзора',
				min_value: 15,
				max_value: 90,
				default_value: 70,
				type: GreenScreenParams.Fov,
			},
			{
				name: 'Высота камеры',
				min_value: 0,
				max_value: 90,
				default_value: 0,
				type: GreenScreenParams.VerticalAngle,
			},
			{
				name: 'Верт. смещение',
				min_value: 100,
				max_value: 100,
				default_value: 0,
				type: GreenScreenParams.VerticalShift,
			},
			{
				name: 'Гориз. смещение',
				min_value: 100,
				max_value: 100,
				default_value: 0,
				type: GreenScreenParams.HorizontalShift,
			},
			{
				name: 'Отдаление от камеры',
				min_value: 0,
				max_value: 100,
				default_value: 40,
				type: GreenScreenParams.DistanceShift,
			},
			{
				name: 'Высота подвески',
				min_value: 50,
				max_value: 100,
				default_value: 0,
				type: GreenScreenParams.SuspensionHeight,
			},
			{
				name: 'Цвет кузова',
				min_value: 0,
				max_value: 0,
				default_value: 0,
				type: GreenScreenParams.BodyColor,
			},
		];
		this.cameraParams.next(cameraParams);
	}

	public getVehicleModels(): IObservable<IGreenScreenVehicleModel[]> {
		return this.vehicleModels;
	}

	public getCameraParams(): IObservable<GreenScreenParamConfig[]> {
		return this.cameraParams;
	}

	public updateParamValue(
		param: GreenScreenParams,
		value: number | RgbColor,
	): void {
		console.log('greenScreen:updateParamValue', {
			param,
			value,
		});
	}

	@throttle(300)
	public swapVehicleModel(model: string): void {
		console.log('greenScreen:swapVehicleModel', {
			model,
		});
	}

	public async takeScreenshot(): Promise<void> {
		console.log('greenScreen:takeScreenshot');
	}

	public async exit(): Promise<void> {
		console.log('greenScreen:exit');
	}
}
